export default __webpack_public_path__ + "static/media/passenger-transit.a17ac4b9.jpg";